import { Download } from "@mui/icons-material";
import { Box } from "@mui/material";
import { GridToolbarProps } from "@mui/x-data-grid";
import { ButtonRow, DateField, FormButton } from "@synota-io/synota-shared-ui";
import { PropsWithChildren, ReactNode } from "react";
import { Control } from "react-hook-form";

export type TableDateFiltersToolbarProps = PropsWithChildren<
  GridToolbarProps & {
    action?: ReactNode;
    control: Control<any>;
    isLoading?: boolean;
    onDownloadClick?: () => void;
  }
>;

export const TableDateFiltersToolbar = ({
  onDownloadClick,
  children,
  action,
  control,
  isLoading,
}: TableDateFiltersToolbarProps) => (
  <ButtonRow p={2}>
    <DateField
      disabled={isLoading}
      size="small"
      label="From Date"
      variant="filled"
      clearable
      control={control}
      name="start_date"
    />
    <DateField
      disabled={isLoading}
      size="small"
      label="To Date"
      variant="filled"
      clearable
      control={control}
      name="end_date"
    />
    {children}
    <Box flexGrow={1} />
    {action}
    {onDownloadClick ? (
      <FormButton
        variant="text"
        startIcon={<Download />}
        isLoading={isLoading}
        onClick={onDownloadClick}
      >
        Download
      </FormButton>
    ) : null}
  </ButtonRow>
);
